export enum enumHtsAssistantMode {
  Live = 'live',
  Readonly = 'readonly',
}
